export default "images/tech.png";